

/** @type {import('./round')} */
module.exports = Math.round;




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/round.js
// module id = ../node_modules/math-intrinsics/round.js
// module chunks = 0